// @flow

import Stores from '@insolus/stores';
import { configure } from 'mobx';
import authStore from 'stores/auth';
import uiStore from 'stores/ui';
import devicesStore from 'stores/devices';

configure({ enforceActions: 'always' });

export default (new Stores({ authStore, uiStore, devicesStore }): Stores);
